import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const PeakSave = {
  Header: lazy(
    () => import('components/direct-sales/peak-save/components/PeakSaveHeader')
  ),
  Content: lazy(
    () => import('components/direct-sales/peak-save/components/PeakSaveContent')
  ),
  Footer: lazy(
    () => import('components/direct-sales/peak-save/components/PeakSaveFooter')
  )
};

export default PeakSave;
